import { SET_TERMS } from "../actionTypes";

const initialState = "";

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TERMS: {
      return action.payload;
    }
    default:
      return state;
  }
};
